import { forwardRef } from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const Input = forwardRef(function Input(
  {
    label,
    error,
    helperText,
    className,
    inputClassName,
    type = 'text',
    required = false,
    disabled = false,
    ...props
  },
  ref
) {
  return (
    <div className={twMerge('w-full', className)}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1 text-start">
          {label}
          {required && <span className="text-red-500 ms-1">*</span>}
        </label>
      )}
      <input
        ref={ref}
        type={type}
        disabled={disabled}
        required={required}
        className={twMerge(
          clsx(
            'block w-full rounded-md border shadow-sm text-sm px-3 py-2',
            'border-gray-300 focus:border-primary-500 focus:ring-primary-500',
            'disabled:bg-gray-100 disabled:cursor-not-allowed disabled:text-gray-500',
            'placeholder:text-gray-400',
            'transition-colors duration-200',
            error && 'border-red-500 focus:border-red-500 focus:ring-red-500',
            inputClassName
          )
        )}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600 text-start">{error}</p>
      )}
      {helperText && !error && (
        <p className="mt-1 text-sm text-gray-500 text-start">{helperText}</p>
      )}
    </div>
  );
});

export default Input;
